import { ColorPalette } from '../../../Palette/ColorPalette';

export interface LegendIntervalsGq {
  readonly start?: number;
  readonly end?: number;
  readonly bgcolor?: string;
}

export const trafficIntervals = (palette: ColorPalette): LegendIntervalsGq[] =>
  [...palette.performanceScale].reverse().map((color, index) => ({
    start: index / palette.performanceScale.length,
    end:
      index === palette.performanceScale.length - 1
        ? null
        : (index + 1) / palette.performanceScale.length,
    bgcolor: color,
  }));
